import { sanitizeTitleFromFilename } from "@/lib/utils/filename";

export const MAX_DOCUMENT_FILE_SIZE_MB = 20;
export const MAX_DOCUMENT_FILE_SIZE_BYTES = MAX_DOCUMENT_FILE_SIZE_MB * 1024 * 1024;

export const DEFAULT_DOCUMENT_TYPE_NAME = "Documento";
export const DEFAULT_DOCUMENT_TYPE_NAMES = ["Exame", "Imagem", "Documento", "Outros"] as const;

export const ACCEPTED_DOCUMENT_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.oasis.opendocument.text",
  "application/vnd.oasis.opendocument.spreadsheet",
  "application/vnd.oasis.opendocument.presentation",
  "text/plain",
  "text/csv",
  "image/jpeg",
  "image/png",
  "image/webp",
] as const;

const ACCEPTED_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".odt",
  ".ods",
  ".odp",
  ".txt",
  ".csv",
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
] as const;

export const DOCUMENT_FILE_ACCEPT = [
  ...ACCEPTED_DOCUMENT_MIME_TYPES,
  ...ACCEPTED_EXTENSIONS,
].join(",");

export const normalizeDocumentTypeName = (value?: string | null) => {
  const normalized = value?.trim();
  return normalized || DEFAULT_DOCUMENT_TYPE_NAME;
};

export const getDocumentTitleFromFilename = (fileName: string) => {
  const title = sanitizeTitleFromFilename(fileName).trim();
  if (title) return title;
  const trimmed = fileName.trim();
  const lastDot = trimmed.lastIndexOf(".");
  return lastDot > 0 ? trimmed.slice(0, lastDot) : trimmed;
};

export const isFileWithinDocumentSizeLimit = (file: File) =>
  file.size <= MAX_DOCUMENT_FILE_SIZE_BYTES;

export const isAcceptedDocumentFile = (file: File) => {
  if (ACCEPTED_DOCUMENT_MIME_TYPES.includes(file.type as (typeof ACCEPTED_DOCUMENT_MIME_TYPES)[number])) {
    return true;
  }

  const lowerName = file.name.toLowerCase();
  return ACCEPTED_EXTENSIONS.some((extension) => lowerName.endsWith(extension));
};
